import { useQuery } from 'react-query';
import { useCurrentUser, useToastProvider } from '@qualio/ui-components';
import tagsApi from '../api/tags.api';
import { DefaultErrorMessage } from '../displayStrings';
export const useTags = () => {
  const { showToast } = useToastProvider();
  const { companyId } = useCurrentUser();

  return useQuery(['tagsList', companyId], () => tagsApi.getAllTags(companyId), {
    enabled: !!companyId,
    staleTime: 5 * 60 * 1000,
    onError: () => {
      showToast({
        title: 'Could not retrieve tags',
        description: DefaultErrorMessage,
        status: 'error',
      });
    },
  });
};
